import { FC } from 'react';
import Typhography from '../Typhography/Typhography';
import { useGoogleSignIn } from './useGoogleSignIn';
import styles from './GoogleSignInButton.module.scss';

interface IGoogleSignInButtonProps {
  /** Riceve l'ID token firmato da Google, da inoltrare al backend. */
  onCredential: (idToken: string) => void;
  /** In px: Google Identity Services non accetta larghezze in percentuale. */
  width?: number;
  /** Messaggio d'errore del login, mostrato sotto il bottone. */
  errorMessage?: string | null;
}

/**
 * «Accedi con Google».
 *
 * Il bottone lo disegna Google dentro il contenitore: non è un nostro
 * `CustomButton` e non può esserlo, perché marchio, testo e proporzioni sono
 * imposti dalle loro linee guida e cambiarli è una violazione.
 *
 * Se il client id non è configurato in questo ambiente il componente non
 * rende nulla: meglio nessun bottone che un bottone che non può funzionare.
 */
const GoogleSignInButton: FC<IGoogleSignInButtonProps> = ({
  onCredential,
  width,
  errorMessage,
}) => {
  const { containerRef, error, isConfigured } = useGoogleSignIn({
    onCredential,
    width,
  });

  if (!isConfigured) return null;

  return (
    <div className={styles.wrap}>
      <div ref={containerRef} className={styles.button} />
      {/* `role` sul contenitore: Typhography non inoltra attributi arbitrari,
          e l'annuncio dell'errore deve comunque arrivare a chi usa uno screen
          reader. */}
      {(error || errorMessage) && (
        <div role="alert">
          <Typhography size="regular-12" className={styles.error}>
            {error ?? errorMessage}
          </Typhography>
        </div>
      )}
    </div>
  );
};

export default GoogleSignInButton;
